import { formatDateWithFormatter } from '@/utils/function'

/**
 * Thời gian chứng từ ký số (requested_at, signed_at, cancelled_at, mails[].created_at,
 * <type>_signed_at ở danh sách...). API trả UTC (ISO 8601, có thể thiếu `Z`): luôn đọc là
 * UTC rồi đổi sang giờ Việt Nam, dạng dd/MM/yyyy HH:mm. Không có giá trị → "—".
 */
export const formatDocumentTime = (value?: string | null) =>
    value
        ? formatDateWithFormatter(value, 'DD/MM/YYYY HH:mm', { fromUTC: true })
        : '—'

/** Tên người thao tác; rỗng (request không gắn nhân viên, dữ liệu test cũ) → "—" */
export const formatActorName = (value?: string | null) => value?.trim() || '—'
